const params=new URLSearchParams(location.search);
const profileHosts=new Set(['voxverse.fr','www.voxverse.fr','profile.dev.voxverse.fr']);
const useApprovedProfile=profileHosts.has(location.hostname)&&params.get('legacy')!=='1';

if(useApprovedProfile){
  document.body.innerHTML='<div id="vox-profile-rebuild"></div>';
  await import('./profile-rebuild/main.js');
}else{
  document.body.innerHTML='<div id="app"></div>';
  await import('./main.js');
}
